import apiClient from './axios.config';
import { API_ENDPOINTS } from '../../constants';

/**
 * Device Attendance Logs API – data sent from ZKTeco device to server
 */
class DeviceAttendanceLogsAPI {
    /**
     * Get device attendance logs with filters and pagination
     * @param {Object} params - Query params: page, limit, date_from, date_to, device_sn, pin, status, sortBy, sortOrder
     * @returns {Promise<Object>}
     */
    async getDeviceAttendanceLogs(params = {}) {
        try {
            const response = await apiClient.get(API_ENDPOINTS.ATTENDANCE_DEVICE_LOGS, { params });
            return response.data;
        } catch (error) {
            console.error('Get device attendance logs error:', error);
            throw error;
        }
    }
}

const deviceAttendanceLogsAPI = new DeviceAttendanceLogsAPI();
export default deviceAttendanceLogsAPI;
